import CrudPage from '../../components/CrudPage'
import { depositosCrud } from '../../api/entities'

// ABM Depósitos (almacenes). Lectura: GET /almacenes?view=BaseList.
// VALIDADO EN VIVO contra el MT (2026-06-25, admin_fvv):
//   ALTA  POST /almacenes { descripcion, modificarPrecioEspecial } -> HTTP 200 (persiste id 35;
//          el backend AUTO-ASIGNA el `codigo` numérico, no lo manda el usuario).
//   EDICIÓN PUT /almacenes/{id} (mismo payload, id en URL) -> HTTP 200.
// La vista BaseList NO trae la clave `codigo` (solo id, descripcion, sucursal,
// modificarPrecioEspecial, listaPrecioVenta, asignarParaSolicitudesNotaCredito,
// porDefectoCargaAutomatica). Por eso NO se muestra columna ni campo `codigo`
// (era un campo inexistente que además rompía el typeahead por el join).
export default function DepositosPage() {
  return (
    <CrudPage
      title="Depósitos"
      api={depositosCrud}
      searchPlaceholder="Buscar por descripción"
      columns={[
        { key: 'descripcion', label: 'Descripción' },
        { key: 'sucursal.nombre', label: 'Sucursal' },
        { key: 'modificarPrecioEspecial', label: 'Precio especial', render: (r) => (r.modificarPrecioEspecial ? 'Sí' : 'No') },
      ]}
      fields={[
        { name: 'descripcion', label: 'Descripción', required: true, full: true },
        { name: 'modificarPrecioEspecial', label: 'Permite modificar precio especial', type: 'checkbox', full: true },
      ]}
      toPayload={(f) => ({ descripcion: f.descripcion, modificarPrecioEspecial: !!f.modificarPrecioEspecial })}
      fromEntity={(e) => ({ descripcion: e.descripcion, modificarPrecioEspecial: e.modificarPrecioEspecial })}
    />
  )
}
